import { render, staticRenderFns } from "./info-block.vue?vue&type=template&id=22b9da0c&scoped=true"
import script from "./info-block.vue?vue&type=script&lang=js"
export * from "./info-block.vue?vue&type=script&lang=js"
import style0 from "./info-block.vue?vue&type=style&index=0&id=22b9da0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9da0c",
  null
  
)

export default component.exports